module.exports = __webpack_public_path__ + "img/paper_torn_light.98387e43.webp";